import { LogoTerraform } from "components/icons/generated";
import VendorVersion from "components/VendorVersion";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableChildRow } from "../types";

const ModulePullRequestsTableRunVendorCell = ({
  item: { run },
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableChildRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <VendorVersion
        icon={LogoTerraform}
        text={run.runtimeConfig?.terraform?.version ?? undefined}
      />
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableRunVendorCell;
